import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE; // Ensure this env variable is set

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// --- Fetch all Tipe Konten with pagination and filters ---
export const fetchTipeKonten = async (filters = {}) => {
  try {
    const params = new URLSearchParams();


    // Conditionally add page and per_page if pagination is NOT disabled
    if (!filters.disable_pagination) {
      params.append('page', filters.page || 1);
      params.append('per_page', filters.per_page || 10);
    } else {
      params.append('disable_pagination', true);
    }

    

    // Add other filters
    if (filters.tipe_konten) {
      params.append('tipe_konten', filters.tipe_konten);
    }
    // Add other specific filters as needed
    // if (filters.id_jenis_soal) { params.append('id_jenis_soal', filters.id_jenis_soal); }
    // if (filters.search) { params.append('search', filters.search); }


    const response = await axios.get(`${BASE_URL_BE}/master_tipe_konten?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    const apiMeta = response.data.meta || {}; // Use a different variable name for clarity
    const returnedData = response.data.data || [];

    let finalMeta = {};

    if (filters.disable_pagination) {
      // When pagination is disabled, treat it as one "page" with all data
      
      finalMeta = {
        page: 1,
        per_page: returnedData.length, // Per_page is effectively the total number of items
        total: returnedData.length,    // Total is also the number of items received
        last_page: 1
      };
    } else {
      // Normal pagination logic
      const currentPage = apiMeta.page || (filters.page || 1);
      const currentPerPage = apiMeta.per_page || (filters.per_page || 10);
      const totalItems = apiMeta.total || 0;
      const calculatedLastPage = Math.ceil(totalItems / (currentPerPage || 1)) || 1;

      finalMeta = {
        page: currentPage,
        per_page: currentPerPage,
        total: totalItems,
        last_page: calculatedLastPage
      };
    }

    return {
      success: true,
      data: returnedData,
      meta: finalMeta
    };
  } catch (error) {
    console.error("Error fetching Tipe Konten:", error);
    throw error.response?.data?.message || error.message || "Failed to fetch Tipe Konten";
  }
};

// --- Create a new Tipe Konten ---
export const createTipeKonten = async (data) => { // Changed from formData to data object
  try {
    const response = await axios.post(`${BASE_URL_BE}/master_tipe_konten`, data, { // Updated endpoint
      headers: {
        ...getAuthHeaders(),
        // Assuming your backend expects application/json for this endpoint based on usecase
        'Content-Type': 'application/json' 
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Tipe Konten:", error);
    // Propagate error with more detail if possible
    throw error.response?.data?.message || error.message || "Failed to create Tipe Konten";
  }
};

// --- Update an existing Tipe Konten ---
export const updateTipeKonten = async (id_tipe_konten, data) => { // Updated parameter name and from formData to data object
  try {
    const response = await axios.put(`${BASE_URL_BE}/master_tipe_konten/${id_tipe_konten}`, data, { // Updated endpoint
      headers: {
        ...getAuthHeaders(),
        // Assuming your backend expects application/json for this endpoint based on usecase
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Tipe Konten:", error);
    // Propagate error with more detail if possible
    throw error.response?.data?.message || error.message || "Failed to update Tipe Konten";
  }
};

// --- Delete a Tipe Konten ---
export const deleteTipeKonten = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/master_tipe_konten/${id}`, { // Updated endpoint
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Tipe Konten:", error);
    // Propagate error with more detail if possible
    throw error.response?.data?.message || error.message || "Failed to delete Tipe Konten";
  }
};
